
export function odometer(container, endDate=null) {

  try {


    if(!endDate) {
      endDate = new Date(container.dataset.endDate?? null);
    }

    container.innerHTML =
      '<div class="om-d" aria-label="Giorni"><div class="om-value">—</div><div class="om-label">Giorni</div></div>' +
      '<div class="om-h" aria-label="Ore"><div class="om-value">—</div><div class="om-label">Ore</div></div>' +
      '<div class="om-m" aria-label="Minuti"><div class="om-value">—</div><div class="om-label">Minuti</div></div>' +
      '<div class="om-s" aria-label="Secondi"><div class="om-value">—</div><div class="om-label">Secondi</div></div>'
    ;

    const labels = {
        d: ['Giorno', 'Giorni'],
        h: ['Ora', 'Ore'],
        m: ['Minuto', 'Minuti'],
        s: ['Secondo', 'Secondi'],
      },
      wrappers = {};

    ['d', 'h', 'm', 's'].forEach(id => {
      const outerWrapper = container.querySelector(`.om-${id}`);
      wrappers[id] = {
        val : outerWrapper.querySelector('.om-value'),
        lab : outerWrapper.querySelector('.om-label')
      };
    });

    const intervalId = setInterval(() => {

      function getTimeParts(endDate) {
        // https://stackoverflow.com/a/13904120/743443

        // get total seconds between the times
        let delta = (endDate - new Date()) / 1000;

        if (delta > 0) {
          const days = Math.floor(delta / 86400);
          delta -= days * 86400;

          const hours = Math.floor(delta / 3600) % 24;
          delta -= hours * 3600;

          const minutes = Math.floor(delta / 60) % 60;
          delta -= minutes * 60;

          const seconds = Math.floor(delta);

          return {d: days, h: hours, m: minutes, s: seconds};

        } else {
          return false;
        }
      }

      const timeParts = new getTimeParts(endDate);

      if(timeParts) {

        ['d', 'h', 'm', 's'].forEach(id => {
          const timeParts = getTimeParts(endDate);
          wrappers[id].val.innerText = timeParts[id];
          wrappers[id].lab.innerText = labels[id][timeParts[id]===1? 0 : 1];
        });

      } else {
        clearInterval(intervalId);
      }
    }, 1000);

  } catch(e) {
    console.error( e ); // eslint-disable-line

  }

}
